import React from 'react'
import { Route } from 'react-router'
const TaxFormsMainPage = React.lazy(() => import('@/modules/taxForms/taxFormMainPage'))
const TaxReports = React.lazy(() => import('@/modules/taxForms/reports/taxReports'))
const UstvaDialog = React.lazy(() => import('@/modules/taxForms/forms').then(mod => ({ default: mod.Ustva.dialog })))
const EuerDialog = React.lazy(() => import('@/modules/taxForms/forms').then(mod => ({ default: mod.Euer.dialog })))

const taxFormsRoutes = (
  <>
    <Route path='taxReports' Component={TaxFormsMainPage} />
    <Route path='taxForms' Component={TaxFormsMainPage} />
    <Route path='taxForms/eur/:hash?' Component={EuerDialog} />
    <Route path='taxForms/ustva/:hash?' Component={UstvaDialog} />
    <Route path='taxReports/:taxKey/:hash?' Component={TaxReports} />
  </>
)

export default taxFormsRoutes
